module.exports = __webpack_public_path__ + "img/alain_chuard.8bb4f6d4.png";